function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.8 90.8",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45.4,
    cy: 49.57,
    r: 23.67,
    style: {
      fill: "none",
      stroke: "inherit",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.26,
    cy: 19.92,
    r: 4.88,
    style: {
      fill: "none",
      stroke: "inherit",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.67,13.34H20.83a7.51,7.51,0,0,0-6.77,4.28,5.42,5.42,0,0,1-4.84,3.2H8.57a5.43,5.43,0,0,1-4.94-7.67A18.83,18.83,0,0,1,20.83,2H70A18.83,18.83,0,0,1,88.8,20.82V70A18.83,18.83,0,0,1,70,88.8H20.83A18.83,18.83,0,0,1,2,70V60.75",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d7fccded.svg";
export { ForwardRef as ReactComponent };